<script>
  

    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
  /**
   * @typedef {Object} Props
   * @property {string} [id]
   * @property {string} [title]
   * @property {any} [icon]
   * @property {any} data
   * @property {boolean} [expand]
   * @property {boolean} [selectable]
   * @property {boolean} [selected]
   * @property {boolean} [hasDelete]
   * @property {boolean} [hasAdd]
   * @property {boolean} [hasEdit]
   * @property {import('svelte').Snippet} [children]
   */

  /** @type {Props} */
  let {
      id = '',
      title = '',
      icon = null,
      data,
      expand = $bindable(false),
      selectable = false,
      selected = $bindable(false),
      hasDelete = false,
      hasAdd = false,
      hasEdit = false,
      children
  } = $props();
    
    const dispatch = createEventDispatcher();

    function handleClick(e) {
        if (e.target.tagName.toLowerCase() !== 'i') {
            expand = !expand;
        } else {
            e.preventDefault();
        }
        dispatch('click', {data, originalEvent: e});
    }

    function handleSelectClick(e) {
        selected = !selected;
        dispatch('select', {data, originalEvent: e});
    }

    function handleDeleteClick(e) {
        dispatch('delete', {data, originalEvent: e});
    }

    function handleAddClick(e) {
        dispatch('add', {data, originalEvent: e});
    }

    function handleEditClick(e) {
        dispatch('edit', {data, originalEvent: e});
    }

</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<div onclick={handleClick} transition:fade class="expanding-row interactive" id={id}>
    {#if selectable}
        <i onclick={handleSelectClick} class="material-icons interactive checkbox {selected ? 'selected' : ''}">{selected ? 'check_box' : 'check_box_outline_blank'}</i>
    {/if}
    {#if icon}
        <i class="material-icons" aria-hidden="true">{icon}</i>
    {/if}
    <span>{title}</span>
    <div class="spacer"></div>
    <div class="right-menu">
        {#if hasAdd}
            <i onclick={handleAddClick} class="material-icons interactive">add</i>
        {/if}
        {#if hasEdit}
            <i onclick={handleEditClick} class="material-icons interactive">edit</i>
        {/if}
        {#if hasDelete}
            <i onclick={handleDeleteClick} class="material-icons interactive">delete</i>
        {/if}
        
    </div>
</div>
{#if expand}
    <div class="expansion">
        {@render children?.()}
    </div>
{/if}

<style>
    .expanding-row{
        display:flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background-color:rgba(255,255,255,0.075);
        padding:0.5rem 1rem;
        border-bottom:1px solid rgba(0,0,0,0.75);
        
    }

    .expanding-row span{
        padding:0.5rem 0;
    }

    .expanding-row i{
        display:flex;
        align-items: center;
        justify-content: center;
        padding:0.5rem;
        
        border-radius:10rem;
    }

    .expanding-row .right-menu i{
        opacity:0.1;
    }
    .expanding-row:hover i{
        opacity:1;
    }

    .expanding-row i:hover{
        background-color:rgba(255,255,255,0.1);
    }
    
    .checkbox{
        margin-right:1rem;
    }

    .checkbox.selected{
        color:rgb(74, 198, 255);
    }

    .expansion{
        display:flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        flex-grow:10;
        background-color:rgba(255,255,255,0);
       
        
    }

    .right-menu{
        display:flex;
        align-items: center;
    }

    .right-menu i:not(:last-of-type){
        margin-right:0.5rem;
    }

    
    
</style>